import React from 'react';
import { Link } from 'react-router-dom';
const Breadcrumb = ({ title, subtitle, homeLabel }) => {
  return (
    <>
      <section
        className="page__title-area page__title-height page__title-overlay 
        d-flex align-items-center"
      style={{
    
    height: '100px',
    padding: '24px 0',
    backgroundColor: ' linear-gradient(to right, #fff 0%, #66696e 50%, #fff 100%)',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    
  }}
      >
        <div className="container">
          <div className="row">
            <div className="col-xxl-12">
              <div className="page__title-wrapper mt-100">
                <div className="breadcrumb-menu">
                  <ul>
                    <li>
  <Link to="/">{homeLabel}</Link>
</li>

                    <li>
                      <span>{title}</span>
                    </li>
                  </ul>
                </div>
                <h3 className="page__title mt-20">{subtitle.toUpperCase()}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Breadcrumb;
